import axios from 'axios';

const httpClient = axios.create({
  // Endpoint paths already include the "/api" prefix (e.g. "/api/Auth/register"),
  // so in production the base is just the origin root. "/api" here would double it
  // to "/api/api/...". "/" also normalises the few paths written without a leading slash.
  baseURL: process.env.REACT_APP_API_URL || '/',
  withCredentials: true, // important for cookie-based auth
  // Массивы шлём повторяющимися ключами (platforms=PS4&platforms=PS5), а не в скобках
  // (platforms[]=...) — иначе ASP.NET не биндит их в List<string> и фильтр игнорируется.
  paramsSerializer: { indexes: null },
});

// Flag to track if auth is in progress
let isAuthInProgress = false;
let authPromise: Promise<void> | null = null;

// Function to set auth state
export const setAuthInProgress = (inProgress: boolean, promise?: Promise<void>) => {
  isAuthInProgress = inProgress;
  authPromise = promise || null;
};

// Function to wait for auth completion
const waitForAuth = async (): Promise<void> => {
  if (isAuthInProgress && authPromise) {
    await authPromise;
  }
};

// Request interceptor to wait for auth
httpClient.interceptors.request.use(
  async (config) => {
    await waitForAuth();
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: on 401/403 clear the local auth flag so the UI reflects logged-out state
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('isLoggedIn');
    }
    return Promise.reject(error);
  }
);

console.log(process.env.REACT_APP_API_URL);
export default httpClient;